import React, { useEffect } from "react";
import { useI18next } from "gatsby-plugin-react-i18next";
import { usePushGtmEvent } from "../hooks/useGmtPushEvent";
import { useLocation, useMatch } from "@reach/router";
import { useI18nLink } from "../hooks/useI18nLink";
import { twMerge } from "tailwind-merge";

const languageName = {
  it: "It",
  en: "En",
  de: "De",
};

type LanguageProps = {
  dark?: boolean;
  className?: string;
};

const Language = (props: LanguageProps) => {
  const { changeLanguage, language: currentLanguage } = useI18next();
  const route = useLocation();
  const matchPrivacy = useMatch("/privacy/*");
  const matchJoin = useMatch("/lavora-con-noi/*");
  const pushGtmEvent = usePushGtmEvent();
  const i18nLink = useI18nLink();

  useEffect(() => pushGtmEvent({ language: currentLanguage }), []);

  if (matchJoin) return null;

  return (
    <select
      onChange={(e) =>
        changeLanguage(
          e.target.value,
          i18nLink(route.pathname, e.target.value, Boolean(matchPrivacy)),
        )
      }
      className={twMerge(
        `rounded-xl text-xs pl-3 pr-7 uppercase font-bold `,
        props.dark
          ? "bg-gray-800 border-gray-700 text-gray-300"
          : "bg-white border-gray-200 text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-300",
        props.className,
      )}
      value={currentLanguage}
    >
      {Object.keys(languageName).map((language) => (
        <option key={language} value={language}>
          {languageName[language]}
        </option>
      ))}
    </select>
  );
};

export default Language;
